import React from 'react';
import { TableRow, TableCell, Typography, Button, Stack, Box } from '@mui/material';

import SetQuantitySelector from '../../SetQuantitySelector/SetQuantitySelector';
import { componentColors } from '/packages/shared-components/utils/color';

export interface TestSet {
  id: string;
  name: string;
  description: string;
  quantity: number;
}

export interface SetSelectionListItemProps {
  set: TestSet;
  onAddSetClick: (set: TestSet) => void;
  onRemoveSetClick: (set: TestSet) => void;
}

const SetSelectionListItem = ({ set, onAddSetClick, onRemoveSetClick }: SetSelectionListItemProps) => {
  const handleAddSetClick = () => onAddSetClick(set);
  const handleRemoveSetClick = () => onRemoveSetClick(set);

  return (
    <Stack
      sx={{
        flexDirection: 'row',
        gap: 2,
        width: '100%',
        p: 2,
        alignItems: 'flex-start',
        borderBottom: (theme) => `1px solid ${componentColors(theme.palette.primary).divider}`,
        backgroundColor: (theme) => {
          if (set.quantity <= 0) return undefined;
          return theme.palette.mode === 'dark'
            ? theme.palette.action.selected
            : componentColors(theme.palette.primary).background;
        },
      }}
    >
      <Stack gap={1.5} flexGrow={1}>
        <Typography variant="subtitle1" sx={{ wordBreak: 'break-all' }}>
          {set.name}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {set.description}
        </Typography>
      </Stack>
      <Box flexShrink={0} width="100px">
        {set.quantity > 0 ? (
          <SetQuantitySelector
            quantity={set.quantity}
            onRemoveClick={handleRemoveSetClick}
            onAddClick={handleAddSetClick}
          />
        ) : (
          <Button variant="outlined" size="small" fullWidth onClick={handleAddSetClick} data-cy={`btn-add-${set.id}`}>
            Add
          </Button>
        )}
      </Box>
    </Stack>
  );
};

export default SetSelectionListItem;
